<div class="wm-m-statedataviewer-wrapper">
  <div class="statedataviewer-stateinfos">
    <div class="info-item creationtime">
      <div class="wm-textwithtoplabel">
        <div class="toplabel">Extraction Time</div>
        <div class="text">{{stateDataInfo?.properties?.creationTime | date:'short' }}</div>
      </div>
    </div>
    <div class="info-item title">
      <div class="wm-textwithtoplabel">
        <div class="toplabel">Title</div>
        <div class="text">{{stateDataInfo?.title}}</div>
      </div>
    </div>
    <div class="info-item viewportsize">
      <div class="wm-textwithtoplabel">
        <div class="toplabel">Viewport Size</div>
        <div class="text">{{stateDataInfo?.properties?.viewportSize?.width}} x {{stateDataInfo?.properties?.viewportSize?.height}}</div>
      </div>
    </div>
  </div>
  <div class="statedataviewer-statedetails">
    <div class="statedataviewer-statecanvas">
      <wm-stateview [noActions]="true" [stateId]="stateId" [infoItems]="rectangles"></wm-stateview>
    </div>
    <div class="statedataviewer-elementinfos">
      @if (!!domStructure) {
        <div class="statedataviewer-elementtree">
          <div class="elementtree-filter">
            <form class="example-form">
              <p-iconfield>
                <p-inputicon>
                  <fa-icon size="lg" icon="search" aria-hidden="true"></fa-icon>
                </p-inputicon>
                <input type="text" #searchInputElem (input)="setSearchInput(searchInputElem.value)" pInputText placeholder="Search">
              </p-iconfield>
            </form>
          </div>
          <div #treeroot class="elementtree-tree">
          </div>
        </div>
      }
      @if (stateDataEmpty) {
        <div class="empty-tree">
          No DOM Tree available
        </div>
      }
      @if (activeNode) {
        <div class="statedataviewer-elementdetails">
          <table class="details-group">
            <tr class="header-row">
              <th colspan="2">General properties</th>
            </tr>
            <tr>
              <td>Node</td>
              <td>{{activeNode.nodeName}}</td>
            </tr>
            <tr>
              <td>Visible</td>
              <td>
                {{activeNode.isElementVisible}}
              </td>
            </tr>
            <tr>
              <td>DOM</td>
              <td>{{activeNode.fullXPath}}</td>
            </tr>
            <tr>
              <td>XPath</td>
              <td>{{activeNode.relativeXPath}}</td>
            </tr>
            <tr>
              <td>Is pseudo element</td>
              <td>{{activeNode.isPseudoElement}}</td>
            </tr>
          </table>
          <table class="details-group">
            <tr class="wm-header-row">
              <th colspan="2">Attributes</th>
            </tr>
            @for (key of activeNodeAttributeKeys(); track key) {
              <tr>
                <td>{{key}}</td>
                <td>{{activeNode.attributes[key]}}</td>
              </tr>
            }
          </table>
          <table class="details-group">
            <tr class="wm-header-row">
              <th colspan="2">Dimensions</th>
            </tr>
            <tr>
            </table>
            <div class="wm-dimensions-wrapper">
              <div class="wm-dimensions">
                <div class="wm-dimensions-top">
                  <div class="wm-dimensions-topleft">({{nodesToRectangles.get(activeNode.nodeId)?.x}}, {{nodesToRectangles.get(activeNode.nodeId)?.y}})</div>
                  <div class="wm-dimensions-topright">({{nodesToRectangles.get(activeNode.nodeId)?.x + activeNode.width}},
                    {{nodesToRectangles.get(activeNode.nodeId)?.y}})
                  </div>
                </div>
                <div class="wm-dimensions-mid">{{activeNode.width}} x {{activeNode.height}}</div>
                <div class="wm-dimensions-bottom">
                  <div class="wm-dimensions-bottomleft">({{nodesToRectangles.get(activeNode.nodeId)?.x}}, {{nodesToRectangles.get(activeNode.nodeId)?.y +
                    activeNode.height}})
                  </div>
                  <div class="wm-dimensions-bottomright">({{nodesToRectangles.get(activeNode.nodeId)?.x + activeNode.width}},
                    {{nodesToRectangles.get(activeNode.nodeId)?.y + activeNode.height}})
                  </div>
                </div>
              </div>
            </div>
            <table class="details-group">
              <tr class="wm-header-row">
                <th colspan="2">CSS properties</th>
              </tr>
              <tr>
                <td>backgroundColor</td>
                <td>{{activeNode.backgroundColor}}</td>
              </tr>
              <tr>
                <td>backgroundImage</td>
                <td>{{activeNode.backgroundImage}}</td>
              </tr>
              <tr>
                <td>borderColor</td>
                <td>{{activeNode.borderColor}}</td>
              </tr>
              <tr>
                <td>borderImage</td>
                <td>{{activeNode.borderImage}}</td>
              </tr>
              <tr>
                <td>borderStyle</td>
                <td>{{activeNode.borderStyle}}</td>
              </tr>
              <tr>
                <td>borderWidth</td>
                <td>{{activeNode.borderWidth}}</td>
              </tr>
              <tr>
                <td>boxShadow</td>
                <td>{{activeNode.boxShadow}}</td>
              </tr>
              <tr>
                <td>color</td>
                <td>{{activeNode.color}}</td>
              </tr>
              <tr>
                <td>content</td>
                <td>{{activeNode.content}}</td>
              </tr>
              <tr>
                <td>clip</td>
                <td>{{activeNode.cssClip}}</td>
              </tr>
              <tr>
                <td>float</td>
                <td>{{activeNode.cssFloat}}</td>
              </tr>
              <tr>
                <td>display</td>
                <td>{{activeNode.display}}</td>
              </tr>
              <tr>
                <td>opacity</td>
                <td>{{activeNode.opacity}}</td>
              </tr>
              <tr>
                <td>opacity effective</td>
                <td>{{activeNode.opacityEffective}}</td>
              </tr>
              <tr>
                <td>outline</td>
                <td>{{activeNode.outlineStyle}}</td>
              </tr>
              <tr>
                <td>overflow-x</td>
                <td>{{activeNode.overflowX}}</td>
              </tr>
              <tr>
                <td>overflow-y</td>
                <td>{{activeNode.overflowY}}</td>
              </tr>
              <tr>
                <td>z-index</td>
                <td>{{activeNode.zindex}}</td>
              </tr>
            </table>
            <table class="details-group">
              <tr class="wm-header-row">
                <th colspan="2">Visibility Details</th>
              </tr>
              <tr>
                <td>visible</td>
                <td>{{activeNode.isElementVisible}}</td>
              </tr>
              <tr>
                <td>border visible</td>
                <td>{{activeNode.borderHasVisibleStyling}}</td>
              </tr>
              <tr>
                <td>has non-zero area</td>
                <td>{{activeNode.hasNonZeroArea}}</td>
              </tr>
              <tr>
                <td>has text content</td>
                <td>{{activeNode.hasTextContent}}</td>
              </tr>
              <tr>
                <td>is text content visible</td>
                <td>{{activeNode.hasTextContentVisible}}</td>
              </tr>
              <tr>
                <td>has visible styling properties</td>
                <td>{{activeNode.hasVisibleStylingProperties}}</td>
              </tr>
            </table>
          </div>
        }
      </div>
    </div>
  </div>
